// extracted by mini-css-extract-plugin
export default {"fieldBox":"CheckBoxUtil_fieldBox__HwBOk","field":"CheckBoxUtil_field__28w3l","label":"CheckBoxUtil_label__DOE2L","labelTxt":"CheckBoxUtil_labelTxt__A77BG"};